export interface Comic {
  id: number;
  title: string;
  genre: string;
  tag: string;
  rating: number;
  status: string;
  chapters: string;
  authors: string;
  description: string;
  imageUrl: string;
  update?: string;
}

export interface RankComic extends Comic {
  trend: 'up' | 'down' | 'same';
}

export interface Category {
  id: number;
  name: string;
  icon: string;
  count: string;
  desc: string;
}

export interface Faq {
  id: number;
  q: string;
  a: string;
}

export interface Testimonial {
  id: number;
  name: string;
  role: string;
  text: string;
}

export const heroBg =
  'https://readdy.ai/api/search-image?query=warm-toned%20vibrant%20anime%20illustration%20of%20a%20bustling%20night%20manga%20city%20street%20with%20glowing%20neon%20signs%2C%20cherry%20blossom%20petals%20floating%20in%20the%20air%2C%20colorful%20comic%20character%20silhouettes%20walking%20by%2C%20dramatic%20sunset%20orange%20and%20golden%20sky%2C%20rich%20ink%20and%20watercolor%20texture%2C%20highly%20detailed%20manga%20cover%20art%20style%2C%20cinematic%20wide%20composition%2C%20soft%20dreamy%20atmosphere&width=1600&height=900&seq=comic-hero-2026&orientation=landscape';

export const heroAccent =
  'https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20young%20female%20manga%20artist%20holding%20a%20stack%20of%20comic%20volumes%2C%20warm%20golden%20studio%20light%2C%20orange%20and%20cream%20palette%2C%20expressive%20eyes%2C%20soft%20paper%20texture%20background%2C%20detailed%20ink%20linework%2C%20charming%20editorial%20anime%20poster%20composition&width=900&height=1100&seq=comic-hero-accent&orientation=portrait';

export const rankHot: RankComic[] = [
  {
    id: 1, title: '炎之契约·刀客传', genre: '热血 · 奇幻', tag: '本周第一',
    rating: 9.8, status: '连载中', chapters: '已更 462 话', authors: '墨白工作室',
    description: '背负家族仇恨的少年刀客，在乱世中与契约之炎同行，一步步揭开身世与王国的秘密。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20heroic%20young%20swordsman%20with%20flowing%20red%20cloak%20standing%20before%20a%20giant%20dragon%20silhouette%2C%20dramatic%20warm%20golden%20backlight%2C%20rich%20orange%20and%20crimson%20palette%2C%20detailed%20ink%20linework%2C%20paper%20texture%20background%2C%20dynamic%20anime%20poster%20style&width=420&height=560&seq=rank-01&orientation=portrait',
    trend: 'up', update: '今日更新',
  },
  {
    id: 2, title: '星界机师', genre: '科幻 · 机甲', tag: '口碑飙升',
    rating: 9.6, status: '连载中', chapters: '已更 288 话', authors: '银河笔社',
    description: '少女机师在星际战场上意外唤醒传说中的王牌机体，卷入一场跨越文明的战争。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20determined%20female%20mecha%20pilot%20in%20a%20cockpit%2C%20warm%20sunset%20light%2C%20orange%20and%20teal%20accents%2C%20dramatic%20cinematic%20lighting%2C%20detailed%20anime%20illustration%2C%20clean%20poster%20composition%2C%20paper%20texture%20background&width=420&height=560&seq=rank-02&orientation=portrait',
    trend: 'up', update: '两日更新',
  },
  {
    id: 3, title: '咒火燎原', genre: '奇幻 · 冒险', tag: '稳定连载',
    rating: 9.5, status: '连载中', chapters: '已更 355 话', authors: '朝露画社',
    description: '平凡学徒掌握禁忌咒火，在学院与遗迹之间追寻力量的真相，热血与温情并存。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20young%20adventurer%20with%20a%20magical%20staff%20casting%20a%20warm%20golden%20fire%20spell%2C%20floating%20sparkles%2C%20night%20city%20background%2C%20orange%20and%20amber%20palette%2C%20dynamic%20action%20pose%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-03&orientation=portrait',
    trend: 'same', update: '三日更新',
  },
  {
    id: 4, title: '侦探社的午后', genre: '推理 · 日常', tag: '口碑黑马',
    rating: 9.4, status: '连载中', chapters: '已更 176 话', authors: '梧桐角',
    description: '慵懒侦探与元气助手经营着一家小侦探社，用细腻推理解开城市里的一个个谜团。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20calm%20young%20detective%20boy%20with%20glasses%20holding%20a%20magnifying%20glass%2C%20warm%20autumn%20street%20background%2C%20cozy%20golden%20tones%2C%20detailed%20ink%20and%20watercolor%20style%2C%20charming%20anime%20poster%20illustration&width=420&height=560&seq=rank-04&orientation=portrait',
    trend: 'up', update: '今日更新',
  },
  {
    id: 5, title: '放学后的天台', genre: '青春 · 校园', tag: '治愈向',
    rating: 9.3, status: '连载中', chapters: '已更 142 话', authors: '橘色屋顶',
    description: '一群少年少女在天台上分享心事与梦想，用温柔日常治愈每一次低落。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20group%20of%20friends%20on%20a%20school%20rooftop%20at%20sunset%2C%20warm%20nostalgic%20golden%20light%2C%20orange%20sky%2C%20lively%20expressive%20faces%2C%20detailed%20slice-of-life%20anime%20illustration%2C%20clean%20poster%20composition&width=420&height=560&seq=rank-05&orientation=portrait',
    trend: 'same', update: '两日更新',
  },
];

export const rankDone: RankComic[] = [
  {
    id: 101, title: '风起苍岚传', genre: '古风 · 武侠', tag: '完结神作',
    rating: 9.7, status: '已完结', chapters: '全 268 话', authors: '墨白工作室',
    description: '乱世侠客执剑行天下，权谋与江湖交织，一部口碑封神的古风武侠长卷。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20wuxia%20swordsman%20standing%20on%20a%20misty%20mountain%20peak%20in%20flowing%20robes%2C%20warm%20sunrise%20light%2C%20orange%20and%20amber%20palette%2C%20ink%20wash%20background%2C%20detailed%20ancient%20chinese%20style%20anime%20illustration%20poster&width=420&height=560&seq=rank-06&orientation=portrait',
    trend: 'same',
  },
  {
    id: 102, title: '时光便利店', genre: '奇幻 · 温情', tag: '治愈完结',
    rating: 9.6, status: '已完结', chapters: '全 180 话', authors: '朝露画社',
    description: '一家只在午夜营业的便利店，每个商品都能换回一段被遗忘的记忆。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20cozy%20midnight%20convenience%20store%20with%20warm%20glowing%20lights%2C%20a%20kind%20shopkeeper%20and%20soft%20floating%20light%20orbs%2C%20orange%20and%20cream%20palette%2C%20heartwarming%20atmosphere%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-07&orientation=portrait',
    trend: 'up',
  },
  {
    id: 103, title: '代号·零度', genre: '科幻 · 冒险', tag: '经典封神',
    rating: 9.5, status: '已完结', chapters: '全 320 话', authors: '银河笔社',
    description: '极寒世界的最后守卫，在废墟中守护人类文明的火种。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20sci-fi%20guardian%20in%20an%20icy%20frozen%20wasteland%20with%20glowing%20warm%20ember%20light%2C%20orange%20and%20cool%20blue%20contrast%2C%20dramatic%20composition%2C%20detailed%20anime%20illustration%20poster%2C%20paper%20texture%20background&width=420&height=560&seq=rank-08&orientation=portrait',
    trend: 'down',
  },
  {
    id: 104, title: '山鬼有灵', genre: '奇幻 · 国风', tag: '国漫之光',
    rating: 9.5, status: '已完结', chapters: '全 208 话', authors: '橘色屋顶',
    description: '山中精怪与人类女孩的约定，一纸契约守护山灵百年。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20spirit%20fox%20girl%20in%20an%20enchanted%20mountain%20forest%2C%20warm%20golden%20fireflies%2C%20orange%20and%20teal%20palette%2C%20folk%20fantasy%20style%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-09&orientation=portrait',
    trend: 'same',
  },
  {
    id: 105, title: '便利店恋歌', genre: '恋爱 · 都市', tag: '甜宠完结',
    rating: 9.3, status: '已完结', chapters: '全 96 话', authors: '梧桐角',
    description: '深夜便利店里，两个陌生人因为一杯热咖啡逐渐靠近彼此。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20romantic%20couple%20sharing%20hot%20coffee%20at%20a%20cozy%20night%20convenience%20store%2C%20warm%20golden%20lighting%2C%20orange%20and%20pink%20tones%2C%20sweet%20atmosphere%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-10&orientation=portrait',
    trend: 'up',
  },
];

export const rankNew: RankComic[] = [
  {
    id: 201, title: '落樱与剑', genre: '古风 · 动作', tag: '新作首推',
    rating: 9.2, status: '连载中', chapters: '已更 24 话', authors: '朝露画社',
    description: '樱花纷落的京都，落魄剑客接下护卫千金的任务，剑光与花雨同时落下。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20samurai%20and%20a%20noble%20lady%20under%20falling%20cherry%20blossoms%2C%20warm%20spring%20light%2C%20orange%20and%20soft%20pink%20palette%2C%20flowing%20kimono%20details%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-11&orientation=portrait',
    trend: 'up',
  },
  {
    id: 202, title: '云端图书馆', genre: '奇幻 · 治愈', tag: '新作黑马',
    rating: 9.1, status: '连载中', chapters: '已更 18 话', authors: '银河笔社',
    description: '漂浮在云端的图书馆里，管理员为每位访客找出一本改变人生的书。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20librarian%20in%20a%20floating%20cloud%20library%20with%20towering%20bookshelves%20and%20warm%20golden%20light%2C%20orange%20and%20cream%20palette%2C%20dreamy%20atmosphere%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-12&orientation=portrait',
    trend: 'up',
  },
  {
    id: 203, title: '夜市侦探', genre: '推理 · 奇幻', tag: '编辑推荐',
    rating: 9.0, status: '连载中', chapters: '已更 31 话', authors: '墨白工作室',
    description: '只在夜晚出现的市集里，侦探用一盏灯笼照出伪装成人的精怪。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20detective%20holding%20a%20glowing%20lantern%20in%20a%20night%20market%2C%20warm%20orange%20lantern%20light%2C%20folk%20fantasy%20atmosphere%2C%20mysterious%20shadows%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-13&orientation=portrait',
    trend: 'same',
  },
  {
    id: 204, title: '第七次心跳', genre: '恋爱 · 悬疑', tag: '口碑新作',
    rating: 8.9, status: '连载中', chapters: '已更 12 话', authors: '梧桐角',
    description: '女孩在每次心跳第七下时看见未来三秒，却始终无法改变命运的一刻。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20mysterious%20girl%20with%20a%20glowing%20heart%20over%20her%20chest%20in%20a%20city%20night%2C%20warm%20amber%20and%20rose%20light%2C%20romantic%20suspense%20mood%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-14&orientation=portrait',
    trend: 'up',
  },
  {
    id: 205, title: '纸鸢传', genre: '国风 · 冒险', tag: '新作首推',
    rating: 8.9, status: '连载中', chapters: '已更 15 话', authors: '橘色屋顶',
    description: '少年工匠造出一只会飞的纸鸢，循着它飞向了云海尽头的秘密。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20boy%20craftsman%20flying%20a%20giant%20paper%20kite%20above%20the%20clouds%2C%20warm%20sunrise%20golden%20light%2C%20orange%20and%20cream%20palette%2C%20traditional%20craft%20details%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-15&orientation=portrait',
    trend: 'same',
  },
];

export const categories: Category[] = [
  { id: 1, name: '热血冒险', icon: 'ri-fire-line', count: '1,286 部', desc: '打斗爽快、成长逆袭，看得过瘾的燃向作品' },
  { id: 2, name: '奇幻玄幻', icon: 'ri-sparkling-line', count: '2,041 部', desc: '魔法、仙侠与异世界的瑰丽想象' },
  { id: 3, name: '恋爱甜宠', icon: 'ri-heart-3-line', count: '1,752 部', desc: '高糖日常与青涩心动，治愈你的少女心' },
  { id: 4, name: '科幻机甲', icon: 'ri-rocket-line', count: '884 部', desc: '星际战争、人工智能与未来科技' },
  { id: 5, name: '推理悬疑', icon: 'ri-search-eye-line', count: '613 部', desc: '烧脑谜团与反转不断的案件' },
  { id: 6, name: '古风武侠', icon: 'ri-sword-line', count: '1,097 部', desc: '刀光剑影与快意恩仇的江湖' },
  { id: 7, name: '青春校园', icon: 'ri-school-line', count: '1,328 部', desc: '天台、操场与教室里的少年时光' },
  { id: 8, name: '悬疑惊悚', icon: 'ri-ghost-line', count: '452 部', desc: '暗夜降临，心跳加速的恐惧体验' },
  { id: 9, name: '日常治愈', icon: 'ri-cup-line', count: '1,109 部', desc: '慢节奏生活与温柔人心' },
  { id: 10, name: '运动竞技', icon: 'ri-basketball-line', count: '376 部', desc: '汗水与呐喊，为梦想拼尽全力' },
  { id: 11, name: '搞笑沙雕', icon: 'ri-emotion-happy-line', count: '968 部', desc: '无厘头日常，笑到停不下来' },
  { id: 12, name: '恐怖猎奇', icon: 'ri-skull-line', count: '287 部', desc: '怪谈与猎奇，勇气者的深夜读物' },
];

export const completedList: Comic[] = [
  {
    id: 301, title: '风起苍岚传', genre: '古风武侠', tag: '完结神作',
    rating: 9.7, status: '已完结', chapters: '全 268 话', authors: '墨白工作室',
    description: '乱世侠客执剑行天下，权谋与江湖交织的封神长卷，一口气追完不后悔。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20wuxia%20swordsman%20standing%20on%20a%20misty%20mountain%20peak%20in%20flowing%20robes%2C%20warm%20sunrise%20light%2C%20orange%20and%20amber%20palette%2C%20ink%20wash%20background%2C%20detailed%20ancient%20chinese%20style%20anime%20illustration%20poster&width=420&height=560&seq=rank-06&orientation=portrait',
  },
  {
    id: 302, title: '时光便利店', genre: '奇幻温情', tag: '治愈完结',
    rating: 9.6, status: '已完结', chapters: '全 180 话', authors: '朝露画社',
    description: '午夜营业的便利店，每个商品都能换回一段被遗忘的记忆，温暖又催泪。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20cozy%20midnight%20convenience%20store%20with%20warm%20glowing%20lights%2C%20a%20kind%20shopkeeper%20and%20soft%20floating%20light%20orbs%2C%20orange%20and%20cream%20palette%2C%20heartwarming%20atmosphere%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-07&orientation=portrait',
  },
  {
    id: 303, title: '代号·零度', genre: '科幻冒险', tag: '经典封神',
    rating: 9.5, status: '已完结', chapters: '全 320 话', authors: '银河笔社',
    description: '极寒世界的最后守卫，在废墟中守护人类文明的火种，格局宏大。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20sci-fi%20guardian%20in%20an%20icy%20frozen%20wasteland%20with%20glowing%20warm%20ember%20light%2C%20orange%20and%20cool%20blue%20contrast%2C%20dramatic%20composition%2C%20detailed%20anime%20illustration%20poster%2C%20paper%20texture%20background&width=420&height=560&seq=rank-08&orientation=portrait',
  },
  {
    id: 304, title: '山鬼有灵', genre: '奇幻国风', tag: '国漫之光',
    rating: 9.5, status: '已完结', chapters: '全 208 话', authors: '橘色屋顶',
    description: '山中精怪与人类女孩的约定，国风美学拉满的奇幻爱情长篇。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20spirit%20fox%20girl%20in%20an%20enchanted%20mountain%20forest%2C%20warm%20golden%20fireflies%2C%20orange%20and%20teal%20palette%2C%20folk%20fantasy%20style%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-09&orientation=portrait',
  },
  {
    id: 305, title: '便利店恋歌', genre: '恋爱都市', tag: '甜宠完结',
    rating: 9.3, status: '已完结', chapters: '全 96 话', authors: '梧桐角',
    description: '深夜便利店里，两个陌生人因为一杯热咖啡逐渐靠近彼此，甜到心坎。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20romantic%20couple%20sharing%20hot%20coffee%20at%20a%20cozy%20night%20convenience%20store%2C%20warm%20golden%20lighting%2C%20orange%20and%20pink%20tones%2C%20sweet%20atmosphere%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-10&orientation=portrait',
  },
  {
    id: 306, title: '弦月之下', genre: '悬疑惊悚', tag: '口碑黑马',
    rating: 9.2, status: '已完结', chapters: '全 142 话', authors: '朝露画社',
    description: '月夜降临后，小镇居民开始忘记白天发生的一切，真相令人不寒而栗。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20lonely%20figure%20under%20a%20huge%20crescent%20moon%20over%20a%20quiet%20town%2C%20moody%20dark%20orange%20and%20indigo%20night%20palette%2C%20mysterious%20suspense%20atmosphere%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=rank-16&orientation=portrait',
  },
];

export const picks: Comic[] = [
  {
    id: 401, title: '画影成书', genre: '奇幻 · 国风', tag: '编辑精选',
    rating: 9.4, status: '连载中', chapters: '已更 66 话', authors: '朝露画社',
    description: '女画师笔下的水墨山水竟能化形为人，与误入画中的少年展开奇缘。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20female%20painter%20with%20a%20living%20ink%20wash%20creature%20stepping%20out%20of%20her%20painting%2C%20warm%20golden%20studio%20light%2C%20orange%20and%20cream%20palette%2C%20traditional%20art%20details%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=pick-01&orientation=portrait',
  },
  {
    id: 402, title: '深夜食堂·妖食记', genre: '奇幻 · 治愈', tag: '高人气',
    rating: 9.3, status: '连载中', chapters: '已更 120 话', authors: '银河笔社',
    description: '妖怪与人类在深夜食堂共进一碗热汤，每个故事都温暖得让人落泪。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20cozy%20night%20diner%20serving%20warm%20steaming%20soup%20to%20spirit%20customers%2C%20warm%20orange%20lamplight%2C%20folk%20fantasy%20atmosphere%2C%20heartwarming%20mood%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=pick-02&orientation=portrait',
  },
  {
    id: 403, title: '机械之心', genre: '科幻 · 情感', tag: '口碑新作',
    rating: 9.1, status: '连载中', chapters: '已更 88 话', authors: '墨白工作室',
    description: '当一台报废机器人拥有了心，它开始思考「活着」究竟意味着什么。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20warm%2C%20expressive%20robot%20with%20a%20glowing%20heart%20core%20in%20a%20sunlit%20junkyard%2C%20orange%20and%20cream%20palette%2C%20emotional%20sci-fi%20mood%2C%20detailed%20anime%20illustration%20poster&width=420&height=560&seq=pick-03&orientation=portrait',
  },
  {
    id: 404, title: '青春回响', genre: '青春 · 校园', tag: '治愈向',
    rating: 9.0, status: '连载中', chapters: '已更 54 话', authors: '梧桐角',
    description: '多年后的同学会上，那些没说出口的话终于有了回响。',
    imageUrl: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20portrait%20of%20a%20nostalgic%20classroom%20reunion%20scene%2C%20warm%20golden%20afternoon%20light%2C%20orange%20and%20cream%20palette%2C%20lively%20expressive%20characters%2C%20slice-of-life%20anime%20illustration%20poster&width=420&height=560&seq=pick-04&orientation=portrait',
  },
];

export const fansubFeatured = {
  id: 501,
  group: '月影汉化组',
  title: '月影汉化组独家：星陨之都（日更中）',
  desc: '由月影汉化组独家译制的科幻冒险力作，全程精翻并附译者注释。每周一至周五早八点准时更新，全站独家免费追更，超 26 万读者正在追更。',
  imageUrl:
    'https://readdy.ai/api/search-image?query=cinematic%20anime%20illustration%20of%20a%20meteor%20falling%20over%20a%20futuristic%20city%20at%20dusk%2C%20warm%20orange%20and%20golden%20glow%2C%20young%20translators%20reviewing%20scripts%20at%20desks%20in%20the%20foreground%2C%20rich%20detail%2C%20a%20legendary%20city%20lit%20by%20falling%20stars%2C%20dramatic%20manga%20cover%20art%20composition%2C%20warm%20tones%2C%20high%20detail&width=1200&height=700&seq=fansub-01&orientation=landscape',
};

export const fansubGroups: { id: number; name: string; works: string; members: string; desc: string }[] = [
  { id: 1, name: '月影汉化组', works: '星陨之都 · 落樱与剑', members: '1,286 位读者', desc: '精翻速递，译者注释详尽' },
  { id: 2, name: '朝露翻译社', works: '画影成书 · 云端图书馆', members: '942 位读者', desc: '擅长国风与治愈系文本' },
  { id: 3, name: '午夜字幕组', works: '夜市侦探 · 弦月之下', members: '761 位读者', desc: '悬疑惊悚类精准把控' },
  { id: 4, name: '星尘汉化组', works: '星界机师 · 机械之心', members: '1,018 位读者', desc: '科幻机甲类深度翻译' },
];

export const testimonials: Testimonial[] = [
  { id: 1, name: '阿澄', role: '追更 3 年', text: '动漫之家的排行榜真的很靠谱，评分高分作基本不会踩雷，完结漫画专区让我一次性追完了好几部封神作。' },
  { id: 2, name: '千叶', role: '国漫爱好者', text: '独家汉化组的翻译质量很高，尤其是国风作品，译者注释讲了很多典故，追起来更有味道。' },
  { id: 3, name: '小满', role: '分类控', text: '分类大全非常细，想找什么类型都能快速定位，还有人气和完结筛选，省了我很多找漫画的时间。' },
  { id: 4, name: '南絮', role: '漫画编辑', text: '编辑精选和每日推荐很有水准，更新也及时。作为一个老漫画迷，我已经把它设为主页了。' },
];

export const faqs: Faq[] = [
  { id: 1, q: '动漫之家漫画网的排行榜多久更新一次？', a: '排行榜数据每天更新。热门榜按当日人气与热度动态排名，完结榜与新作榜每周日晚进行一次大更新，你可以在「排行榜」板块查看详细榜单。' },
  { id: 2, q: '什么是「独家汉化组」内容？', a: '独家汉化组内容是指由动漫之家漫画网官方合作汉化组（如月影汉化组）译制并在全站独家首发的作品。这些作品带独家标识，通常更新更快、翻译更精细，并附有译者注释。' },
  { id: 3, q: '完结漫画专区里都是完整完结的作品吗？', a: '是的。完结漫画专区收录了已经全篇完结的漫画，并标注「全 N 话」，你可以直接从第一话一口气看到结局，不用担心断更或烂尾。' },
  { id: 4, q: '我想按类型找漫画，应该怎么浏览？', a: '进入「漫画分类大全」板块，可按热血冒险、恋爱甜宠、科幻机甲、古风武侠等类型筛选。每个分类下都有人气排序与完结筛选，帮你快速定位想看的作品。' },
  { id: 5, q: '如何追踪我正在追的漫画更新？', a: '在作品页点击「追更」即可把漫画加入你的追更列表。连载作品更新时会通过站内消息提醒你，新作与热门推荐也会按你的偏好推送。' },
  { id: 6, q: '动漫之家漫画网的内容是免费的吗？', a: '动漫之家漫画网绝大多数作品都是免费在线观看的，包括大部分独家汉化组内容。部分作品可能设有平台活动，具体以作品页面标注为准。' },
];